var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.showPhoneList)?_c(_setup.PhoneTasksListView):(_setup.showDesktopList)?_c(_setup.TasksView,{attrs:{"assignee-me":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }